const denormalizer = ({ pageSize, pageNo }: any) => {
  return {
    pageSize,
    pageNo,
  }
}

export default denormalizer
